<div class="d-flex flex-column align-items-center m-3">
  <img
    class="img-thumbnail rounded-circle mb-3"
    src="../assets/img/identity-image.png"
    width="44"
    height="44"
    alt="Identity image" />
  <div class="account-name" data-qa-id="opened-menu-name">{{ userName }}</div>
</div>
